import React, {useEffect, useState} from 'react';
import {Form, Row, Col, Input, Button} from 'antd';
import {DownOutlined, UpOutlined} from '@ant-design/icons';
import {observer} from 'mobx-react';

import styles from './index.module.less';
import {useTranslation} from "react-i18next";


export class SearchFormItem extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <Col span={this.props.span} offset={this.props.offset}>
        <Form.Item label={this.props.title} name={this.props.name} className={styles.searchFormItem}>
          {this.props.children}
        </Form.Item>
      </Col>
    )
  }
}

export default observer(function (props) {
  const {t, i18n} = useTranslation()
  const [expand, setExpand] = useState(false)
  const [form] = Form.useForm()

  useEffect(()=>{
    setExpand(props.expand);
  },[props.expand]);

  const onFinish = (values) => {
    props.onFinish(values)
  }

  const onReset = () => {
    form.resetFields();
    props.onReset && props.onReset() || props.onFinish({});
  }

  return (
    <div className={styles.searchFormBox} style={{height: !expand ? '0.21875rem' : props.height ? props.height : '0.588542rem'}}>
      <Form style={props.style}
            form={form}
            name="advanced_search"
            className={styles.searchForm}
            onFinish={onFinish}>

        <Row>
          {props.children}
        </Row>

        <div className={styles.btns}>
          <Button onClick={() => onReset()}>{t('重置')}</Button>
          <Button style={{margin: '0 0.0417rem'}} type="primary" htmlType="submit">{t('搜索')}</Button>
          <Button style={{marginRight: '0.0417rem',display:props.isExport?'inline-block':'none'}} onClick={()=>{props.onExport()}} type="primary">{props.isExportDetail?t('导出行'):t('导出')}</Button>
          <Button style={{marginRight: '0.0417rem',display:props.isExportDetail?'inline-block':'none'}} onClick={()=>{props.onExportDetail()}} type="primary">{t('导出明细')}</Button>

          <a onClick={() => props.setExpand?props.setExpand(!expand):setExpand(!expand)}>
            {!expand ? <span><DownOutlined/> {t('展开')}</span> : <span><UpOutlined/> {t('收起')}</span>}
          </a>
        </div>

      </Form>
    </div>
  )
})
